import React       from 'react';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';

import { GameState }       from '../models/Enums';
import AARPAuthService     from '../services/AARPAuthService';
import { AARPInternalAPI } from '../services/AARPInternalAPI';
import { Analytics }       from '../services/Analytics/Analytics';
import { AARPAnalytics }   from '../services/Analytics/AARPAnalytics';

type RouterWrapperProps = {
    pathname: string;
    gameState: GameState;
    replace: any;
    children: any;
};

interface RootState {
    gameState: GameState;
    router:any
}

class RouterWrapperBase extends React.PureComponent<RouterWrapperProps> {
    static displayName = 'RouterWrapper';
    scrollTop: boolean = false;
    wasReloaded: boolean = false;

    adTimer: any = -1;
    adTimerTrackPageView: any = -1;

    componentDidUpdate() {
        if (this.scrollTop) {
            window.scrollTo(0, 0);
            this.scrollTop = false;
        }
    }

    componentWillReceiveProps(nextProps: RouterWrapperProps) {
        if (this.wasReloaded) { return; }

        if (this.props.pathname !== nextProps.pathname) {
            const gameLoaded = [
                GameState.GAME, GameState.GAME_END, GameState.GAME_SCORE_SAVED
            ].indexOf(nextProps.gameState) !== -1;

            if (gameLoaded) {
                this.wasReloaded = true;
                this.props.replace(this.props.pathname);
                window.location.replace(nextProps.pathname);
                return;
            } else {
                // Simulate standard browser navigation
                AARPAnalytics.virtualPageLoad();
                this.scrollTop = true;
                clearTimeout(this.adTimerTrackPageView);
                this.adTimerTrackPageView = setTimeout(() => Analytics.trackPageView(true), 500);

                clearTimeout(this.adTimer);
                this.adTimer = setTimeout(() => AARPInternalAPI.initRightRail(true), 250);
                AARPAuthService.updateLoginData();
            }
        }
    }

    render() {
        return <div>{this.props.children}</div>;
    }
}

export const RouterWrapper = connect(
    (state: RootState) => ({
        pathname: state.router.location.pathname,
        gameState: state.gameState,
    }),
    { replace }
)(RouterWrapperBase);
